(function(){
  function init(){
    var drawer=document.getElementById('CartDrawer');
    document.querySelectorAll('[data-cart-open]').forEach(function(trigger){trigger.addEventListener('click',function(event){if(!drawer)return;event.preventDefault();document.querySelectorAll('dialog[open]').forEach(function(dialog){dialog.close();});drawer.showModal();document.body.classList.add('locked');});});
    var footer=document.querySelector('.footer-refined');
    if(footer&&'IntersectionObserver' in window){
      var floatingBars=Array.from(document.querySelectorAll('.mobile-dock'));
      new IntersectionObserver(function(entries){
        var atFooter=entries[0].isIntersecting;
        document.body.classList.toggle('footer-in-view',atFooter);
        floatingBars.forEach(function(bar){bar.inert=atFooter;});
      },{threshold:0}).observe(footer);
    }
    var filters=document.querySelector('[data-local-color-filter]');
    if(filters){var cards=Array.from(document.querySelectorAll('[data-catalog-color]'));var initial=new URL(location.href).searchParams.getAll('colour');filters.querySelectorAll('input').forEach(function(input){input.checked=initial.includes(input.value);});
      function filter(){var selected=Array.from(filters.querySelectorAll('input:checked')).map(function(i){return i.value;});var count=0;cards.forEach(function(card){card.hidden=selected.length>0&&!selected.includes(card.dataset.catalogColor);if(!card.hidden)count++;});var empty=document.querySelector('[data-color-empty]');if(empty)empty.hidden=count>0;}
      filter();
    }
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
